import { render } from "./HeroiconsOutlineLightBulb.vue?vue&type=template&id=64c6d7d3"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineLightBulb.vue"]])

export default __exports__